<template>
    <div :class="[bulletClasses]">
        <p v-if="message.userName" class="is-size-7 is-capitalized">
            {{ message.userName }}
        </p>
        <p>{{ text }}</p>
    </div>
</template>

<script>
export default {
    name: "chat-message",
    props: {
        message: { type: Object, required: true },
    },
    computed: {
        text() {
            return this.message.text || this.message.notification;
        },

        bulletClasses() {
            if (this.message.notification)
                return ["is-notification", "has-text-centered"];
            if (this.message.userName)
                return [
                    "font-14",
                    "p-3 mb-2",
                    "has-text-white",
                    "is-message",
                    "is-other",
                    "has-text-left",
                    "has-background-primary",
                ];
            return [
                "font-14",
                "p-3 mb-2",
                "has-text-white",
                "is-message",
                "is-my",
                "has-text-right",
                "has-background-secondary",
            ];
        },
    },
};
</script>

<style lang="scss">
.is-notification {
    width: 100%;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    & p {
        background-color: whitesmoke !important;
        width: auto;
        margin-left: 15%;
        margin-right: 15%;
        border-radius: 25px;
    }
}

.is-message {
    border-radius: 25px;
    width: fit-content;
    max-width: 75%;
}

.is-other {
    border-bottom-left-radius: 0px;
    margin-left: 1rem;
    margin-right: auto;
}

.is-my {
    border-bottom-right-radius: 0px;
    margin-right: 1rem;
    margin-left: auto;
}
</style>